import { Col, Image, Row } from "react-bootstrap"
import blague from "../images/positionImage.jpeg"
import React from "react"
import MyMap from "./map"

export default function Position() {
  return (
    <Row
      className="researchRow"
      style={{ display: "flex", alignItems: "center" , justifyContent: "center"}}
    >
      <Col
        xs={12}
        md={6}
        className=""
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "space-between",
        }}
      >
       <MyMap/>
      </Col>
      <Col xs={12} md={4} className="">
        <p style={{ color: "floralWhite", textAlign: "center" }}>
          <br/>
          Franck Polleux
            <br/>
          Principal Investigator
            <br/>
          T: +1-212-853-0407
            <br/>
          E: fp2304@cumc.columbia.edu
          <br/>
          <br/>
          <br/>
          Rhythm Sharma
          <br/>
          Lab Manager
            <br/>
          T: +1-212-853-0406
            <br/>
          E: rs4039@columbia.edu

        </p>
      </Col>

    </Row>
  )
}
